const state = {
  current: {},
}

const actions = {
  async setCurrent({ commit }, data) {
    commit('SET_CURRENT', data)
  },
}

const mutations = {
  SET_CURRENT(state, payload) {
    state.current = payload
  },
}

const getters = {
  get: (state) => state.current,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
